import { getRandom, tsParticles } from "@tsparticles/engine";
$.fn.particles = function () {
    const baseId = "tsparticles";
    const init = (options, callback) => {
        this.each((index, element) => {
            if (element.id === undefined) {
                element.id = baseId + Math.floor(getRandom() * 1000);
            }
            tsParticles.load({ id: element.id, options }).then(callback);
        });
    };
    const ajax = (jsonUrl, callback) => {
        this.each((index, element) => {
            if (element.id === undefined) {
                element.id = baseId + Math.floor(getRandom() * 1000);
            }
            tsParticles.load({ id: element.id, url: jsonUrl }).then(callback);
        });
    };
    return { init, ajax };
};
